import { Component } from '@angular/core';

@Component({
  selector: 'app-login-signup-with-otp',
  templateUrl: './login-signup-with-otp.component.html',
  styleUrls: ['./login-signup-with-otp.component.css']
})
export class LoginSignupWithOtpComponent {

enteredNumber=false;
enteredOTP=false;
enteredAddress=false;
  EnterPhoneNumber(){
    this.enteredNumber=true;
    this.enteredOTP=false;
    this.enteredAddress=false;
  }

  EnterOTP(){
   this.enteredOTP=true;
   this.enteredNumber=false;
  
  }
}
